import { h, FunctionalComponent } from 'preact'
import { TranslationContext } from '../../libs/translationsUtils/context'

interface Props {
  date: string
}

const DateFormatter: FunctionalComponent<Props> = (props: Props) => {
  return (
    <TranslationContext.Consumer>
      {({ language }) => {
        return new Intl.DateTimeFormat(language, {
          year: 'numeric',
          month: 'short',
          day: 'numeric'
        }).format(new Date(props.date).getTime())
      }}
    </TranslationContext.Consumer>
  )
}

export default DateFormatter
